import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Container, Box, Paper } from '@mui/material';
import { useSettingsContext } from 'src/components/settings';
import { useParams } from 'react-router';
import axiosInstance from 'src/api/axiosInstance';
import { enqueueSnackbar } from 'notistack';
import { getCurrentProject, getCurrentServer, getMandEndPoint } from 'src/helper/server-address';
import EmployeeReplicaForm from '../employeeReplicaForm';
import EmployeeReplicaEditView from './emplyeeReplicaEditView';

export default function EmployeeReplicaCreateView({ type }) {
  const settings = useSettingsContext();
  const { id } = useParams(); // this will be candidateId or employeeId
  const [empData, setEmpData] = useState(null);
  const [candidateData, setCandidateData] = useState(null);

  console.log('EmployeeReplicaCreateView props:', { type, id });
  useEffect(() => {
    if (!id) return;

    if (type === 'employee') {
      // Existing employee logic
      axiosInstance
        .get(`/rest/employee/external/singleEmpDetails/${id}`)
        .then((response) => {
          setEmpData(response.data);
        })
        .catch((error) => {
          enqueueSnackbar('Error fetching employee details', { variant: 'error' });
        });
    }

    if (type === 'candidate') {
      // New candidate logic
      axiosInstance
        .get(`/rest/candidate/external/singleCandDetails/${id}`)
        .then((response) => {
          setCandidateData(response.data); // Reuse same state
        })
        .catch((error) => {
          enqueueSnackbar('Error fetching candidate details', { variant: 'error' });
        });
    }
  }, [id, type]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <Box
        component={Paper}
        elevation={3}
        sx={{
          border: '1px solid #ccc',
          borderRadius: 2,
          p: 4,
          mb: 2,
          boxShadow: 3,
          backgroundColor: 'background.paper',
        }}
      >
        {type === 'employee' ? (
          <EmployeeReplicaEditView currentEmp={empData} type={type} />
        ) : (
          <EmployeeReplicaForm candidateId={id} candidateData={candidateData} />
        )}
      </Box>
    </Container>
  );
}

EmployeeReplicaCreateView.propTypes = {
  type: PropTypes.oneOf(['candidate', 'employee']).isRequired,
};
